/*
 * Admin Dashboard
 */
import React, { useEffect, useState, useMemo } from "react";
import {
  Col,
  Row,
  Typography,
  Avatar,
  Button,
  Dropdown,
  Divider,
  Menu,
  Select,
  Tag,
  Space,
  Modal,
} from "antd";
import { Link } from "react-router-dom";
import {
  // EditOutlined,
  // PlusOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  GiftOutlined,
} from "@ant-design/icons";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LabelList,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";

//import { ToastContainer } from "react-toastify";
import * as action from "../../store/Dashboard/actions";
import * as employeeAction from "../../store/Employee/actions";
import * as leaveAction from "../../store/LeaveAndPermission/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import dayjs from "dayjs";
const AdminDashboard = () => {
  const userRole = localStorage.getItem("userType");
  const dispatch = useDispatch();
  const specificDispatch = useDispatch();
  useEffect(() => {
    if (userRole === "admin") {
      dispatch(action.loadBirthdayList());
      dispatch(employeeAction.loadEmployee());
      dispatch(leaveAction.loadLeaveDetails());
      dispatch(leaveAction.loadLOP());
      dispatch(leaveAction.loadPermission());
      dispatch(action.loadHolidayList());
      dispatch(action.loadDepartment());
      dispatch(action.loadAttendanceTodayOverview());
      dispatch(action.loadAttendanceOverview());
      dispatch(action.loadLate());
      dispatch(action.loadEmployeeType());
    }
  }, [dispatch, userRole]);

  const update = useSelector((state) => state.Dashboard);
  const {
    birthday_list = [],
    holiday_list = [],
    department_list = {},
    attendanceTodayOverview_list = {},
    attendanceThisWeekOverview_list = {},
    attendanceThisMonthOverview_list = {},
    AttendanceOverview_list = [],
    late_list = [],
    employeeType_list,
  } = update;
  const dropdownUpdate = useSelector((specificstate) => specificstate.Employee);
  const { employee_list = {} } = dropdownUpdate;
  const employeeList = employee_list ? employee_list.data : [];
  //dropdown state from reducer
  const dropdownLeaveUpdate = useSelector(
    (specificstate) => specificstate.Leave
  );
  const {
    leaveList = [],
    permissionList = [],
    lopList = [],
  } = dropdownLeaveUpdate;
  const permissionListCount =
    permissionList?.data?.filter((l) => l.PermissionStatus === "Pending") || [];
  const lopCount =
    lopList?.data?.filter((l) => l.lopStatus === "Pending") || [];

  const approvePendingList = permissionListCount.length + lopCount.length;

  const leavePendingList = !isEmpty(leaveList.data)
    ? leaveList.data.filter((l) => l.leaveStatus === "Pending")
    : [];
  const leavePendingCount = !isEmpty(leavePendingList)
    ? leavePendingList.length
    : 0;

  const [isExpandedView, setIsExpandedView] = useState(false);

  const toggleEmployeeView = () => {
    setIsExpandedView((prev) => !prev);
  };

  const visibleEmployees = isExpandedView
    ? employeeList || []
    : (employeeList || []).slice(0, 5);

  //dropdown initial state

  const [departments, setDepartments] = useState();

  //data for chart
  const departmentCountMap = Array.isArray(employeeList)
    ? employeeList.reduce((acc, emp) => {
        const deptName = emp.departmentId?.departmentName || "Unknown";
        acc[deptName] = (acc[deptName] || 0) + 1;
        return acc;
      }, {})
    : {};

  const data = Object.entries(departmentCountMap).map(([name, value]) => ({
    name,
    value,
  }));


  //dropdown options
  const departmentOptions = !isEmpty(department_list.result)
    ? department_list.result
    .filter(f => f.status === "ACTIVE")
    .map((d) => {
        return {
          label: d.departmentName,
          value: d.departmentName,
        };
      })
    : [];


  // Generate an array of the last 10 years starting from 2025
 // const currentYear = 2025;
 // const years = Array.from({ length: 10 }, (_, index) => currentYear - index);


  ///  Birthday
  const [showBirthdayModal, setShowBirthdayModal] = useState(false);

  const today = moment();
  const startOfThisMonth = today.clone().startOf("month");
  const endOfNextMonth = today.clone().add(1, "month").endOf("month");

  // Grid View (Filtered: this + next month)
  const labeledItems = !isEmpty(birthday_list)
    ? birthday_list
        .map((item) => {
          const dob = moment(item.DOB, "YYYY-MM-DD");
          const dobThisYear = dob.clone().year(today.year());

          if (
            dobThisYear.isBefore(startOfThisMonth) ||
            dobThisYear.isAfter(endOfNextMonth)
          ) {
            return null;
          }

          const dobDM = dob.format("DD-MM");
          const todayDM = today.format("DD-MM");
          const tomorrowDM = today.clone().add(1, "day").format("DD-MM");

          if (dobDM === todayDM) {
            return { ...item, group: "Today", sortOrder: 0 };
          } else if (dobDM === tomorrowDM) {
            return { ...item, group: "Tomorrow", sortOrder: 1 };
          } else {
            return {
              ...item,
              group: dob.format("DD MMM"),
              sortOrder: 2,
              groupDate: dobThisYear.toDate(),
            };
          }
        })
        .filter(Boolean)
    : [];

  const grouped = labeledItems.reduce((acc, item) => {
    const groupKey = item.group || "Others";
    acc[groupKey] = acc[groupKey] || {
      items: [],
      sortOrder: item.sortOrder,
      groupDate: item.groupDate || null,
    };
    acc[groupKey].items.push(item);
    return acc;
  }, {});

  const limitedGroups = Object.entries(grouped).sort(
    (a, b) => a[1].sortOrder - b[1].sortOrder
  );

  // Modal View (All birthdays)
  const allLabeledItems = !isEmpty(birthday_list)
    ? birthday_list
        .map((item) => {
          const dob = moment(item.DOB, "YYYY-MM-DD");
          const dobThisYear = dob.clone().year(today.year());

          const dobDM = dob.format("DD-MM");
          const todayDM = today.format("DD-MM");
          const tomorrowDM = today.clone().add(1, "day").format("DD-MM");

          if (dobDM === todayDM) {
            return { ...item, group: "Today", sortOrder: 0 };
          } else if (dobDM === tomorrowDM) {
            return { ...item, group: "Tomorrow", sortOrder: 1 };
          } else {
            return {
              ...item,
              group: dob.format("DD MMM"),
              sortOrder: 2,
              groupDate: dobThisYear.toDate(),
            };
          }
        })
        .filter(Boolean)
    : [];

  const allGrouped = allLabeledItems.reduce((acc, item) => {
    const groupKey = item.group || "Others";
    acc[groupKey] = acc[groupKey] || {
      items: [],
      sortOrder: item.sortOrder,
      groupDate: item.groupDate || null,
    };
    acc[groupKey].items.push(item);
    return acc;
  }, {});

  const sortedAllGroups = Object.entries(allGrouped).sort(
    (a, b) => a[1].sortOrder - b[1].sortOrder
  );

  //holiday

  const [showModal, setShowModal] = useState(false);

  // ✅ Filter holidays only in this & next month
  const filteredGridHolidays = holiday_list.filter((item) => {
    const date = moment(item.date);
    return date.isBetween(startOfThisMonth, endOfNextMonth, "day", "[]");
  });

  // ✅ Get the nearest upcoming holiday from filtered ones
  const upcomingHoliday = filteredGridHolidays
    .filter((item) => moment(item.date).isSameOrAfter(today, "day"))
    .sort((a, b) => moment(a.date) - moment(b.date))[0];

  // ✅ Grouping logic for the grid
  // Group holidays for grid (this & next month only)
  const groupedGridHolidays = filteredGridHolidays.reduce((acc, item) => {
    const date = moment(item.date);
    const key = date.format("YYYY-MM"); // Sort-friendly key
    acc[key] = acc[key] || { label: date.format("MMMM YYYY"), items: [] };
    acc[key].items.push(item);
    return acc;
  }, {});

  // Sort the groups by YYYY-MM format
  const sortedGridGroups = Object.entries(groupedGridHolidays).sort(
    ([a], [b]) => moment(a, "YYYY-MM") - moment(b, "YYYY-MM")
  );

  // Get first group
  const firstGroup =
    sortedGridGroups.length > 0 ? sortedGridGroups[0][1] : null;

  const holidayItems = !isEmpty(holiday_list)
    ? holiday_list
        .map((item) => {
          const date = moment(item.date);
          if (date.isSame(today, "day")) {
            return { ...item, group: "Today", sortOrder: 0 };
          } else if (date.isSame(today.clone().add(1, "day"), "day")) {
            return { ...item, group: "Tomorrow", sortOrder: 1 };
          } else {
            return {
              ...item,
              group: date.format("DD MMM YYYY"),
              sortOrder: 2,
              groupDate: date.toDate(),
            };
          }
        })
        .filter(Boolean)
    : [];

  const groupedHolidays = holidayItems.reduce((acc, item) => {
    const key = item.group || "Others";
    acc[key] = acc[key] || {
      items: [],
      sortOrder: item.sortOrder ?? 999,
      groupDate: item.groupDate || null,
    };
    acc[key].items.push(item);
    return acc;
  }, {});

  const sortedHolidayGroups = Object.entries(groupedHolidays).sort((a, b) => {
    const [, aVal] = a;
    const [, bVal] = b;
    if (aVal.sortOrder !== bVal.sortOrder)
      return aVal.sortOrder - bVal.sortOrder;
    if (
      aVal.sortOrder === 2 &&
      aVal.groupDate instanceof Date &&
      bVal.groupDate instanceof Date
    )
      return aVal.groupDate - bVal.groupDate;
    return 0;
  });

  const limitedHolidayGroups = sortedHolidayGroups.map(([label, val]) => ({
    label,
    items: val.items,
  }));
  const handleHolidayModalCancel = () => {
    setShowModal(false);
  };
  const { Title, Text } = Typography;
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  /// attendance view
  const attendanceViewDetails = AttendanceOverview_list;
  // Filter by department
  const filteredData = departments
    ? attendanceViewDetails.filter((emp) => emp.department === departments)
    : attendanceViewDetails;

  const toggleDetails = (empId) => {
    setSelectedEmployeeId((prev) => (prev === empId ? null : empId));
  };

  const dotStyle = (color) => ({
    color,
    fontWeight: "100",
    marginRight: 2,
    fontSize: "20px",
    lineHeight: "1",
    verticalAlign: "middle",
  });

  /*
   *  Attendance overview
   */

 
  const [isAbsenteeModalOpen, setIsAbsenteeModalOpen] = useState(false);
  const [filter, setFilter] = useState("Today");
  const [pieData, setPieData] = useState([]);
  const [total, setTotal] = useState(0);
  const [gridData, setGridData] = useState([]);

  const handleMenuClick = (e) => {
    setFilter(e.key);
  };

  const menuDay = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="Today">Today</Menu.Item>
      <Menu.Item key="This Week">This Week</Menu.Item>
      <Menu.Item key="This Month">This Month</Menu.Item>
    </Menu>
  );
  // attendance clock in clock out
  const [label, setLabel] = useState("Today");
  const filteredLateData = departments
    ? late_list.filter((emp) => emp.departmentName === departments)
    : late_list;
  const [lateModalVisible, setLateModalVisible] = useState(false);

  const handleClockClick = (e) => {
    setLabel(e.key);
    const payload = e.key === "Today" ? dayjs().format("YYYY-MM-DD") : e.key;
    specificDispatch(action.loadAttendanceOverview({ date: payload }));
    specificDispatch(action.loadLate(payload));
  };
  const clockDay = (
    <Menu onClick={handleClockClick}>
      <Menu.Item key="Today">Today</Menu.Item>
      <Menu.Item key="This Week">This Week</Menu.Item>
      <Menu.Item key="This Month">This Month</Menu.Item>
    </Menu>
  );
  const allDates = Array.from(
    new Set(
      filteredData.flatMap((emp) =>
        emp.intervalDatas.map((interval) => interval.date)
      )
    )
  );

  const showGroupedByDate = allDates.length > 1;

  useEffect(() => {
    const searchFilter = {}; // Customize this if needed (e.g., by department, dates)

    if (filter === "Today") {
      dispatch(action.loadAttendanceTodayOverview(searchFilter));
    } else if (filter === "This Week") {
      dispatch(action.loadAttendanceThisWeekOverview(searchFilter));
    } else if (filter === "This Month") {
      dispatch(action.loadAttendanceThisMonthOverview(searchFilter));
    }
  }, [filter, dispatch]);

  useEffect(() => {
    let sourceData = {};

    if (filter === "Today") {
      sourceData = attendanceTodayOverview_list;
    } else if (filter === "This Week") {
      sourceData = attendanceThisWeekOverview_list;
    } else if (filter === "This Month") {
      sourceData = attendanceThisMonthOverview_list;
    }

    const statusData =
      sourceData?.data ||
      sourceData?.weeklyData ||
      sourceData?.monthlyData ||
      {};

    const computedPie = [
      {
        name: "Present",
        value: statusData?.present?.percentage || 0,
        color: "#52c41a",
      },
      {
        name: "LOP",
        value: statusData?.lop?.percentage || 0,
        color: "#faad14",
      },
      {
        name: "Permission",
        value: statusData?.permission?.percentage || 0,
        color: "#13c2c2",
      },
      {
        name: "Absent",
        value: statusData?.absent?.percentage || 0,
        color: "#ff4d4f",
      },
      {
        name: "Forget Login",
        value: statusData?.forgetLogin?.percentage || 0,
        color: "#e30556",
      },
    ];

    setPieData(computedPie);

    const totalCount =
      (statusData?.present?.count || 0) +
      (statusData?.lop?.count || 0) +
      (statusData?.permission?.count || 0) +
      (statusData?.absent?.count || 0) +
      (statusData?.forgetLogin?.count || 0);

    setTotal(totalCount);
    setGridData(sourceData?.details || []);
  }, [
    filter,
    attendanceTodayOverview_list,
    attendanceThisWeekOverview_list,
    attendanceThisMonthOverview_list,
  ]);


  /*Employee List*/

  const [segments, setSegments] = useState([]);

  const employeeTypeColors = useMemo(
    () => ({
      "Full-Time Employee": "#4CAF50",
      "Part-Time Employee": "#FF9800",
      "Contract Employee": "#2196F3",
      "Consultant": "#9C27B0",
      "Temporary Employee": "#FFC107",
      "Intern / Trainee": "#0e2447",
      "Freelancer": "#FF5722",
      "WFH Employee": "#607D8B",
      "undefined": "#e82517",
    }),
    []
  );

  // Clean backend data
  const employeeTypeData = employeeType_list?.data || [];

  const cleanedData = employeeTypeData.map((item) => {
    const type = (item.employeeType || "undefined").trim(); // Trim added
    return {
      type,
      count: item.count,
      percentage: item.percentage,
    };
  });

  const totalEmployees = employeeType_list?.totalEmployees || 0;

  // Calculate segments
  useEffect(() => {
    const totalPct = cleanedData.reduce(
      (acc, item) => acc + item.percentage,
      0
    );
    const scale = totalPct ? 100 / totalPct : 0;

    const segmentArray = cleanedData.map((item) => ({
      width: item.percentage * scale,
      color: employeeTypeColors[item.type] || "#cccccc",
    }));

    setSegments(segmentArray);
  }, [cleanedData, employeeTypeColors]); 

  return (
    <div>
      <Row gutter={[16, 16]} align="stretch" className="p-2">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div className="bg-white rounded-md shadow w-full p-4 flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-4 flex-1 min-w-0">
              <Avatar
                size={48}
                style={{
                  backgroundColor: "#8400ff",
                  textTransform: "capitalize",
                }}
              >
                D
              </Avatar>
              <div className="flex-1 min-w-0">
                <Typography.Title level={4} className="poppins-txt title">
                  Welcome Back, Admin{" "}
                {/* //  <EditOutlined className=" edit-iconBtn text-gray-500" /> */}
                </Typography.Title>
                <Typography.Text className="poppins-txt subtext">
                  You have{" "}
                  <span className="text-orange-500">{approvePendingList}</span>{" "}
                  Pending Approvals &{" "}
                  <Link
                    to="/leave-details"
                    className="text-orange-500"
                    style={{ textDecoration: "underline" }}
                  >
                    {leavePendingCount}
                  </Link>{" "}
                  Leave Requests
                </Typography.Text>
              </div>
            </div>
            {/* <div className=" flex gap-2 w-full md:w-auto md:justify-end justify-start">
              <Button
                style={{ background: "#342242" }}
                type="primary"
                size="medium"
                className="custom-btn"
                icon={<PlusOutlined />}
              >
                Add Project
              </Button>
              <Button
                style={{ background: "#f97316" }}
                type="primary"
                size="medium"
                className="custom-btn"
                icon={<PlusOutlined />}
              >
                Add Request
              </Button>
            </div> */}
          </div>
        </Col>
      </Row>

      <Row gutter={[16, 16]} align="stretch" className="p-2">
        <Col xs={24} sm={24} md={24} lg={24} xl={16}>
          <Row gutter={[16, 16]} align="stretch">
            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
              <div className="bg-white rounded-md shadow w-full   p-5">
                <div className="attendance-header">
                  <div className="attendance-icon mb-2  bg-[#52C41A]">
                    <CalendarOutlined />
                  </div>
                  <div>
                    <Typography className="attendance-label poppins-txt">
                      Attendance
                    </Typography>
                    <div className="attendance-value poppins-txt">
                      92/99{" "}
                      <span className="attendance-change poppins-txt">
                        +2.1%
                      </span>
                    </div>
                  </div>
                </div>
                <div className="poppins-txt grey-text mt-2">View Details</div>
              </div>
            </Col>

            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
              <div className="bg-white rounded-md shadow w-full  p-5">
                <div className="attendance-header">
                  <div className="attendance-icon mb-2 bg-[#FAAD14]">
                    <CalendarOutlined />
                  </div>
                  <div>
                    <Typography className="attendance-label poppins-txt">
                      Attendance
                    </Typography>
                    <div className="attendance-value poppins-txt">
                      92/99{" "}
                      <span className="attendance-change poppins-txt">
                        +2.1%
                      </span>
                    </div>
                  </div>
                </div>
                <div className="poppins-txt grey-text  mt-2">View Details</div>
              </div>
            </Col>

            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
              <div className="bg-white rounded-md shadow w-full p-5">
                <div className="attendance-header">
                  <div className="attendance-icon mb-2  bg-[#1890FF]">
                    <CalendarOutlined />
                  </div>
                  <div>
                    <Typography className="attendance-label poppins-txt">
                      Attendance
                    </Typography>
                    <div className="attendance-value poppins-txt">
                      92/99{" "}
                      <span className="attendance-change poppins-txt">
                        +2.1%
                      </span>
                    </div>
                  </div>
                </div>
                <div className="poppins-txt grey-text  mt-2">View Details</div>
              </div>
            </Col>

            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
              <div className="bg-white rounded-md shadow w-full p-5">
                <div className="attendance-header">
                  <div className="attendance-icon mb-2  bg-[#52C41A]">
                    <CalendarOutlined />
                  </div>
                  <div>
                    <Typography className="attendance-label poppins-txt">
                      Attendance
                    </Typography>
                    <div className="attendance-value poppins-txt">
                      92/99{" "}
                      <span className="attendance-change poppins-txt">
                        +2.1%
                      </span>
                    </div>
                  </div>
                </div>
                <div className="poppins-txt grey-text  mt-2">View Details</div>
              </div>
            </Col>

            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
              <div className="bg-white rounded-md shadow w-full  p-5">
                <div className="attendance-header">
                  <div className="attendance-icon mb-2  bg-[#52C41A]">
                    <CalendarOutlined />
                  </div>
                  <div>
                    <Typography className="attendance-label poppins-txt">
                      Attendance
                    </Typography>
                    <div className="attendance-value poppins-txt">
                      92/99{" "}
                      <span className="attendance-change poppins-txt">
                        +2.1%
                      </span>
                    </div>
                  </div>
                </div>
                <div className="poppins-txt grey-text  mt-2">View Details</div>
              </div>
            </Col>

            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
              <div className="bg-white rounded-md shadow w-full  p-5">
                <div className="attendance-header">
                  <div className="attendance-icon mb-2  bg-[#1890FF]">
                    <CalendarOutlined />
                  </div>
                  <div>
                    <Typography className="attendance-label poppins-txt">
                      Attendance
                    </Typography>
                    <div className="attendance-value poppins-txt">
                      92/99{" "}
                      <span className="attendance-change poppins-txt">
                        +2.1%
                      </span>
                    </div>
                  </div>
                </div>
                <div className="poppins-txt grey-text  mt-2">View Details</div>
              </div>
            </Col>

            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
              <div className="bg-white rounded-md shadow w-full  p-5">
                <div className="attendance-header">
                  <div className="attendance-icon mb-2">
                    <CalendarOutlined />
                  </div>
                  <div>
                    <Typography className="attendance-label poppins-txt">
                      Attendance
                    </Typography>
                    <div className="attendance-value poppins-txt">
                      92/99{" "}
                      <span className="attendance-change poppins-txt">
                        +2.1%
                      </span>
                    </div>
                  </div>
                </div>
                <div className="poppins-txt grey-text  mt-2">View Details</div>
              </div>
            </Col>

            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
              <div className="bg-white rounded-md shadow w-full  p-5">
                <div className="attendance-header">
                  <div className="attendance-icon mb-2">
                    <CalendarOutlined />
                  </div>
                  <div>
                    <Typography className="attendance-label poppins-txt">
                      Attendance
                    </Typography>
                    <div className="attendance-value poppins-txt">
                      92/99{" "}
                      <span className="attendance-change poppins-txt">
                        +2.1%
                      </span>
                    </div>
                  </div>
                </div>
                <div className="poppins-txt grey-text  mt-2">View Details</div>
              </div>
            </Col>
          </Row>
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={8}>
          <div className="bg-white rounded-md shadow w-full h-full">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography.Title
                className="m-5 poppins-txt font-weight"
                level={5}
              >
                Employees By Department
              </Typography.Title>
              {/* <div className="mr-5 mt-2">
                <Dropdown overlay={menu} trigger={["click"]}>
                  <Button icon={<CalendarOutlined />}>2025</Button>
                </Dropdown>
              </div> */}
            </div>
            <Divider className="my-4" />
            <div>
              <ResponsiveContainer width="100%" height={200}>
                <BarChart
                  data={data}
                  layout="vertical"
                  margin={{ top: 0, right: 30, left: 20, bottom: 5 }}
                >
                  <XAxis
                    type="number"
                    domain={[0, 50]}
                    ticks={[0, 10, 20, 30, 40, 50]}
                  />
                  <YAxis
                    type="category"
                    dataKey="name"
                    tick={{ fontSize: 15 }}
                    width={100}
                  />
                  <Tooltip />
                  <Bar
                    dataKey="value"
                    fill="#f97316"
                    barSize={20}
                    radius={[0, 10, 10, 0]}
                  >
                    <LabelList
                      dataKey="value"
                      position="insideRight"
                      fill="#fff"
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="mx-5 mb-5">
              <Typography.Text
                type="secondary"
                className="poppins-txt bar-text"
              >
                <span
                  style={{
                    color: "#f97316",
                    fontWeight: "100",
                    marginRight: 4,
                    fontSize: "25px",
                    lineHeight: "1",
                    verticalAlign: "middle",
                  }}
                >
                  &#8226;
                </span>{" "}
                No of Employees increased by Leave Requests{" "}
                <span style={{ color: "lightgreen" }}>+20%</span> from last Week
              </Typography.Text>
            </div>
          </div>
        </Col>
      </Row>

      <Row gutter={[16, 16]} align="stretch" className="p-2">
        <Col xs={24} sm={24} md={24} lg={24} xl={8} style={{ display: "flex" }}>
          <div className="bg-white rounded-md shadow w-full  ">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
              className="p-5"
            >
              <Typography.Title className=" poppins-txt font-weight" level={5}>
                Employee Status
              </Typography.Title>
            </div>
            <Divider className=" w-full" type="secondary" />
            <div className="p-5">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                className="pb-5"
              >
                <Typography.Text className=" poppins-txt" type="secondary">
                  Total Employee
                </Typography.Text>
                <div className="font-weight">{totalEmployees}</div>
              </div>
              <div
                style={{
                  height: "34px",
                  display: "flex",
                  gap: "2px",
                  backgroundColor: "#E6DCE8",
                  borderRadius: "8px",
                }}
              >
                {segments.map((segment, index) => (
                  <div
                    key={index}
                    style={{
                      width: `${segment.width}%`,
                      backgroundColor: segment.color,
                      borderRadius: "5px",
                      height: "100%",
                    }}
                  />
                ))}
              </div>
              <Row className="my-2">
                {cleanedData.map((item, index) => (
                  <Col xs={12} sm={12} md={8} lg={8} xl={8} key={index}>
                    <div
                      className="border border-grey bg-white"
                      style={{
                        padding: "8px",
                        fontSize: "12px",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          fontSize: "11px",
                          color: "#888",
                        }}
                      >
                        <span
                          style={{
                            color:
                              employeeTypeColors[item.type?.trim()] ||
                              "#cccccc",
                            fontSize: "14px",
                            lineHeight: "1",
                          }}
                        >
                          &#8226;
                        </span>
                        <span>{item.type}</span>
                      </div>

                      <div style={{ fontSize: "10px", fontWeight: 500 }}>
                        ({item.percentage}%)
                      </div>

                      <div style={{ fontSize: "20px", fontWeight: "bold" }}>
                        {item.count}
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>

              <div className="my-2 poppins-txt">
                <Typography.Text strong>Top Performer</Typography.Text>
              </div>
              <div
                className="bg-white rounded-md shadow w-full "
                style={{ border: "1px solid #FF5733" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="p-3"
                >
                  <div className="flex items-center gap-3">
                    <Avatar
                      style={{
                        backgroundColor: "#8400ff",
                        textTransform: "capitalize",
                      }}
                      size={48}
                    >
                      D
                    </Avatar>
                    <div>
                      <Typography.Text strong>Daniel</Typography.Text>
                      <div className="text-gray-500 text-sm">IOS Developer</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <Typography.Text type="secondary" className="text-sm block">
                      Performance
                    </Typography.Text>
                    <Typography.Text strong style={{ color: "red" }}>
                      99%
                    </Typography.Text>
                  </div>
                </div>
              </div>

              <div className="text-center mt-4 poppins-txt">
                <Link to="/employee-management">
                  <Button block className="custom-btn">
                    View All Employees
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={8} style={{ display: "flex" }}>
          <div className="bg-white rounded-md shadow w-full">
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
              className="p-5"
            >
              <Typography.Title className="poppins-txt font-weight" level={5}>
                Attendance Overview
              </Typography.Title>
              <Dropdown overlay={menuDay} trigger={["click"]}>
                <Button icon={<CalendarOutlined />}>{filter}</Button>
              </Dropdown>
            </div>

            <Divider className="mb-4 w-full" type="secondary" />

            <div className="flex justify-center items-center my-3 relative">
              <PieChart width={350} height={150}>
                <Pie
                  data={pieData}
                  startAngle={180}
                  endAngle={0}
                  dataKey="value"
                  cx="50%"
                  cy="100%"
                  innerRadius={90}
                  outerRadius={140}
                  fill="#8884d8"
                  paddingAngle={2}
                >
                  {pieData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
              <Typography.Text
                style={{
                  position: "absolute",
                  top: "70%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                Total Attendance
              </Typography.Text>
              <Typography.Title
                level={3}
                style={{
                  position: "absolute",
                  top: "70%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
                className="poppins-text"
              >
                {total}
              </Typography.Title>
            </div>

            <div className="p-5">
              <div className="my-2 poppins-txt">
                <Typography.Text strong>Status</Typography.Text>
              </div>

              {pieData.map((item) => (
                <div
                  key={item.name}
                  className="flex justify-between poppins-txt"
                >
                  <div className="grey-text">
                    <span
                      style={{
                        color: item.color,
                        fontWeight: "100",
                        marginRight: 4,
                        fontSize: "25px",
                        lineHeight: "1",
                        verticalAlign: "middle",
                      }}
                    >
                      &#8226;
                    </span>
                    {item.name}
                  </div>
                  <div>{item.value}%</div>
                </div>
              ))}

              <div className="mt-5 flex justify-between items-center poppins-txt">
                <Space size="small">
                  <Typography.Text className="poppins-txt">
                    Total Absentees
                  </Typography.Text>
                  <Avatar.Group max={{ count: 3 }}>
                    {(() => {
                      let absentees = [];

                      if (filter === "Today") {
                        absentees = (gridData || []).filter(
                          (e) => e.status?.toLowerCase() === "absent"
                        );
                      } else if (filter === "This Week") {
                        absentees =
                          attendanceThisWeekOverview_list?.absentDetails || [];
                      } else if (filter === "This Month") {
                        absentees =
                          attendanceThisMonthOverview_list?.absentDetails || [];
                      }

                      return absentees.map((emp, index) => (
                        <Avatar
                          key={index}
                          style={{
                            backgroundColor: "#8400ff",
                            textTransform: "capitalize",
                          }}
                          size={38}
                        >
                          {emp.employeeName?.[0] || "A"}
                        </Avatar>
                      ));
                    })()}
                  </Avatar.Group>
                </Space>
                <Typography.Link
                  onClick={() => setIsAbsenteeModalOpen(true)}
                  style={{ color: "orange", textDecoration: "underline" }}
                >
                  View Details
                </Typography.Link>
              </div>
            </div>
            <Modal
              title={`Absent Employees – ${filter}`}
              open={isAbsenteeModalOpen}
              onCancel={() => setIsAbsenteeModalOpen(false)}
              footer={null}
              centered
            >
              {(() => {
                let absentees = [];

                if (filter === "Today") {
                  absentees = (
                    attendanceTodayOverview_list?.details || []
                  ).filter((e) => e.status?.toLowerCase() === "absent");
                } else if (filter === "This Week") {
                  absentees =
                    attendanceThisWeekOverview_list?.absentDetails || [];
                } else if (filter === "This Month") {
                  absentees =
                    attendanceThisMonthOverview_list?.absentDetails || [];
                }

                if (absentees.length === 0) {
                  return (
                    <Typography.Text type="secondary">
                      No absentees found.
                    </Typography.Text>
                  );
                }

                return (
                  <>
                    <Typography.Text strong>
                      Total absentees: {absentees.length}
                    </Typography.Text>

                    {absentees.map((emp, idx) => (
                      <div
                        key={idx}
                        className="poppins-txt my-2 flex items-center"
                      >
                        <Avatar
                          style={{
                            backgroundColor: "#8400ff",
                            marginRight: 8,
                            textTransform: "capitalize",
                          }}
                        >
                          {emp.employeeName?.[0] || "A"}
                        </Avatar>
                        {emp.employeeName}{" "}
                        <Typography.Text
                          type="secondary"
                          style={{ marginLeft: 4 }}
                        >
                          ({emp.employeeCode})
                        </Typography.Text>
                      </div>
                    ))}
                  </>
                );
              })()}
            </Modal>
          </div>
        </Col>

        {/* <Col xs={24} sm={24} md={24} lg={24} xl={8} style={{ display: "flex" }}>
          <div className="bg-white rounded-md shadow w-full">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
              className="p-5"
            >
              <div>
                <Typography.Title
                  className=" poppins-txt font-weight"
                  level={5}
                >
                  Clock In/Out
                </Typography.Title>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <div>
                  <Select
                    placeholder="All Departments"
                    allowClear
                    className="custom-select"
                    name="departments"
                    value={departments}
                    onChange={(event, newValue) => setDepartments(newValue)}
                    options={departmentOptions}
                    autoComplete="off"
                    dropdownRender={(menu) => (
                      <div className="option-text-font">{menu}</div>
                    )}
                  />
                </div>
                <div>
                  <Dropdown overlay={menuDay} trigger={["click"]}>
                    <Button icon={<CalendarOutlined />}>Today</Button>
                  </Dropdown>
                </div>
              </div>
            </div>
            <Divider className="w-full" type="secondary" />
            <div className="p-5">
              <div className="bg-white rounded-md shadow w-full ">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="p-2"
                >
                  <div className="flex items-center gap-3">
                    <Avatar
                      style={{
                        backgroundColor: "#8400ff",
                        textTransform: "capitalize",
                      }}
                      size={38}
                    >
                      D
                    </Avatar>
                    <div>
                      <Typography.Text strong>Daniel</Typography.Text>
                      <div className="text-gray-500 text-sm">IOS Developer</div>
                    </div>
                  </div>
                  <div className="text-right gap-2">
                    <ClockCircleOutlined className="text-md text-gray-500 mr-1" />
                    <Tag className="bg-[#33EA26] text-white">09:15</Tag>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-md shadow w-full my-2">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="p-2"
                >
                  <div className="flex items-center gap-3">
                    <Avatar
                      style={{
                        backgroundColor: "#8400ff",
                        textTransform: "capitalize",
                      }}
                      size={38}
                    >
                      D
                    </Avatar>
                    <div>
                      <Typography.Text strong>Daicy</Typography.Text>
                      <div className="text-gray-500 text-sm">
                        Backend Developer
                      </div>
                    </div>
                  </div>
                  <div className="text-right gap-2">
                    <ClockCircleOutlined className="text-md text-gray-500 mr-1" />
                    <Tag className="bg-[#33EA26] text-white">09:15</Tag>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-md shadow w-full my-2">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="p-2"
                >
                  <div className="flex items-center gap-3">
                    <Avatar
                      style={{
                        backgroundColor: "#8400ff",
                        textTransform: "capitalize",
                      }}
                      size={38}
                    >
                      A
                    </Avatar>
                    <div>
                      <Typography.Text strong>Arun</Typography.Text>
                      <div className="text-gray-500 text-sm">
                        Frontend Developer
                      </div>
                    </div>
                  </div>
                  <div className="text-right gap-2">
                    <ClockCircleOutlined className="text-md text-gray-500 mr-1" />
                    <Tag className="bg-[#33EA26] text-white">09:15</Tag>
                  </div>
                </div>
                <div className="bg-white rounded-md shadow p-3">
                  <Row justify="space-around" align="middle">
                    <Col>
                      <Typography.Text className="poppins-text">
                        <span
                          style={{
                            color: "green",
                            fontWeight: "100",
                            marginRight: 2,
                            fontSize: "20px",
                            lineHeight: "1",
                            verticalAlign: "middle",
                          }}
                        >
                          &#8226;
                        </span>{" "}
                        Clock in
                        <div>10:30 AM</div>
                      </Typography.Text>
                    </Col>
                    <Col>
                      <Typography.Text className="poppins-text">
                        <span
                          style={{
                            color: "red",
                            fontWeight: "100",
                            marginRight: 2,
                            fontSize: "20px",
                            lineHeight: "1",
                            verticalAlign: "middle",
                          }}
                        >
                          &#8226;
                        </span>{" "}
                        Clock Out
                        <div>9:45 AM</div>
                      </Typography.Text>
                    </Col>
                    <Col>
                      <Typography.Text className="poppins-text">
                        <span
                          style={{
                            color: "yellow",
                            fontWeight: "100",
                            marginRight: 2,
                            fontSize: "20px",
                            lineHeight: "1",
                            verticalAlign: "middle",
                          }}
                        >
                          &#8226;
                        </span>{" "}
                        Production
                        <div>9:21 Hrs</div>
                      </Typography.Text>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="mb-1 poppins-txt">
                <Typography.Text strong>Late</Typography.Text>
              </div>
              <div className="bg-white rounded-md shadow w-full my-2">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="p-2"
                >
                  <div className="flex items-center gap-3">
                    <Avatar
                      style={{
                        backgroundColor: "#8400ff",
                        textTransform: "capitalize",
                      }}
                      size={38}
                    >
                      D
                    </Avatar>
                    <div>
                      <Typography.Text strong>Daniel</Typography.Text>
                      <Tag
                        className="bg-[#33EA26] text-white ml-2"
                        icon={
                          <ClockCircleOutlined className="text-md text-gray-500" />
                        }
                      >
                        30 Min
                      </Tag>
                      <div className="text-gray-500 text-sm">IOS Developer</div>
                    </div>
                  </div>

                  <div className="text-right gap-2">
                    <ClockCircleOutlined className="text-md text-gray-500 mr-1" />

                    <Tag className="bg-[#FD0707] text-white">09:15</Tag>
                  </div>
                </div>
              </div>
              <div className="text-center mt-4 poppins-txt">
                <Link to="/attendance-detail">
                  <Button block className="custom-btn">
                    View All Attendance
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </Col> */}
        <Col xs={24} sm={24} md={24} lg={24} xl={8} style={{ display: "flex" }}>
          <div className="bg-white rounded-md shadow w-full">
            <div className="p-5 flex justify-between">
              <Title level={5} className="poppins-txt font-weight">
                Clock In/Out
              </Title>
              <div style={{ display: "flex", gap: 8 }}>
                <Select
                  placeholder="All Departments"
                  allowClear
                  //  className="custom-select"
                  value={departments}
                  onChange={(value) => setDepartments(value)}
                  options={departmentOptions}
                  style={{
                    width: 120, // reduce width
                    fontSize: 12, // shrink font
                  }}
                  dropdownStyle={{ fontSize: 12 }}
                />
                <div>
                  <Dropdown overlay={clockDay} trigger={["click"]}>
                    <Button icon={<CalendarOutlined />}>{label}</Button>
                  </Dropdown>
                </div>
              </div>
            </div>

            <Divider className="w-full" type="secondary" />

            <div className="p-5">
              {/* Employee Cards (Scrollable) */}
              <div
                className="custom-scroll"
                style={{ maxHeight: "350px", overflowY: "auto" }}
              >
                {showGroupedByDate
                  ? allDates.map((date) => (
                      <div key={date}>
                        <h5 className="mb-2 mt-4">
                          {moment(date).format("DD MMM YYYY")}
                        </h5>
                        {filteredData.map((employee) => {
                          const interval = employee.intervalDatas.find(
                            (d) => d.date === date
                          );
                          if (!interval) return null;

                          return (
                            <div
                              className="bg-white rounded-md shadow w-full my-2"
                              key={employee.employeeId + date}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                                className="p-2"
                              >
                                <div className="flex items-center gap-3">
                                  <Avatar
                                    style={{
                                      backgroundColor: "#8400ff",
                                      textTransform: "capitalize",
                                    }}
                                    size={38}
                                  >
                                    {employee.employeeName
                                      .charAt(0)
                                      .toUpperCase()}
                                  </Avatar>
                                  <div>
                                    <Text strong>{employee.employeeName}</Text>
                                    <div className="text-gray-500 text-sm">
                                      {employee.department}
                                    </div>
                                  </div>
                                </div>
                                <div className="text-right gap-2">
                                  <ClockCircleOutlined className="text-md text-gray-500 mr-1" />
                                  <Tag
                                    className="bg-[#33EA26] text-white"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      toggleDetails(employee.employeeId)
                                    }
                                  >
                                    {interval.netWorkDuration !== "0"
                                      ? interval.netWorkDuration
                                      : "0 Hrs"}
                                  </Tag>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ))
                  : filteredData.slice(0, 10).map((employee) => {
                      const interval = employee.intervalDatas?.[0] || {};
                      return (
                        <div
                          className="bg-white rounded-md shadow w-full my-2"
                          key={employee.employeeId}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="p-2"
                          >
                            <div className="flex items-center gap-3">
                              <Avatar
                                style={{
                                  backgroundColor: "#8400ff",
                                  textTransform: "capitalize",
                                }}
                                size={38}
                              >
                                {employee.employeeName.charAt(0).toUpperCase()}
                              </Avatar>
                              <div>
                                <Text strong>{employee.employeeName}</Text>
                                <div className="text-gray-500 text-sm">
                                  {employee.department}
                                </div>
                              </div>
                            </div>
                            <div className="text-right gap-2">
                              <ClockCircleOutlined className="text-md text-gray-500 mr-1" />
                              <Tag
                                className="bg-[#33EA26] text-white"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  toggleDetails(employee.employeeId)
                                }
                              >
                                {interval.netWorkDuration !== "0"
                                  ? interval.netWorkDuration
                                  : "0 Hrs"}
                              </Tag>
                            </div>
                          </div>
                        </div>
                      );
                    })}
              </div>

              {/* Bottom Clock In/Out Details (Dynamic) */}
              {selectedEmployeeId && (
                <div className="bg-white rounded-md shadow p-3 my-3">
                  {(() => {
                    const emp = filteredData.find(
                      (e) => e.employeeId === selectedEmployeeId
                    );
                    const empName = emp.employeeName;
                    const data = emp?.intervalDatas?.[0] || {};
                    return (
                      <>
                        {/* ✅ Show Employee Name */}
                        <Text strong className="poppins-text mb-3 block">
                          {empName}
                        </Text>

                        <Row justify="space-around" align="middle">
                          <Col>
                            <Text className="poppins-text">
                              <span style={dotStyle("green")}>•</span> Clock in
                              <div>{data.login}</div>
                            </Text>
                          </Col>
                          <Col>
                            <Text className="poppins-text">
                              <span style={dotStyle("red")}>•</span> Clock Out
                              <div>{data.logout}</div>
                            </Text>
                          </Col>
                          <Col>
                            <Text className="poppins-text">
                              <span style={dotStyle("orange")}>•</span>{" "}
                              Production
                              <div>{data.netWorkDuration}</div>
                            </Text>
                          </Col>
                        </Row>
                      </>
                    );
                  })()}
                </div>
              )}

              {/* Static Late Section */}
              {/* <div className="mb-1 poppins-txt">
                    <Text strong>Late</Text>
                  </div>
                  <div className="bg-white rounded-md shadow w-full my-2">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      className="p-2"
                    >
                      <div className="flex items-center gap-3">
                        <Avatar style={{ backgroundColor: "#8400ff" }} size={38}>
                          D
                        </Avatar>
                        <div>
                          <Text strong>Daniel</Text>
                          <Tag
                            className="bg-[#33EA26] text-white ml-2"
                            icon={
                              <ClockCircleOutlined className="text-md text-gray-500" />
                            }
                          >
                            30 Min
                          </Tag>
                          <div className="text-gray-500 text-sm">IOS Developer</div>
                        </div>
                      </div>
                      <div className="text-right gap-2">
                        <ClockCircleOutlined className="text-md text-gray-500 mr-1" />
                        <Tag className="bg-[#FD0707] text-white">09:15</Tag>
                      </div>
                    </div>
                  </div> */}
              {filteredLateData.length > 0 && (
                <div>
                  <div className="mb-1 poppins-txt">
                    <Text strong>Late</Text>
                  </div>
                  {/* Only first late entry */}
                  <div className="bg-white rounded-md shadow w-full my-2">
                    <div className="p-2 flex justify-between items-center">
                      <div className="flex items-center gap-3">
                        <Avatar
                          style={{ backgroundColor: "#8400ff" }}
                          size={38}
                        >
                          {filteredLateData[0].employeeName
                            .charAt(0)
                            .toUpperCase()}
                        </Avatar>
                        <div>
                          <Text strong>{filteredLateData[0].employeeName}</Text>
                          <Tag
                            className="bg-[#33EA26] text-white ml-2"
                            icon={<ClockCircleOutlined />}
                          >
                            {filteredLateData[0].minutesDifference} Min
                          </Tag>
                          <div className="text-gray-500 text-sm">
                            {filteredLateData[0].designationName}
                          </div>
                        </div>
                      </div>
                      <div className="text-right">
                        <ClockCircleOutlined className="text-md text-gray-500 mr-1" />
                        <Tag className="bg-[#FD0707] text-white">
                          {filteredLateData[0].login}
                        </Tag>
                      </div>
                    </div>
                  </div>

                  {/* View All Link */}
                  <div className="text-right">
                    <Button
                      type="link"
                      className="poppins-txt"
                      onClick={() => setLateModalVisible(true)}
                    >
                      View All Late
                    </Button>
                  </div>
                </div>
              )}

              {/* View All Button */}
              <div className="text-center mt-4 poppins-txt">
                <Link to="/attendance-detail">
                  <Button block className="custom-btn">
                    View All Attendance
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </Col>
        <Modal
          open={lateModalVisible}
          onCancel={() => setLateModalVisible(false)}
          footer={null}
          title="All Late Records"
          width={450}
          maskClosable={false}
          centered
        >
          {Object.entries(
            filteredLateData.reduce((acc, item) => {
              const dateKey = moment(item.date).format("DD MMMM, YYYY");
              if (!acc[dateKey]) acc[dateKey] = [];
              acc[dateKey].push(item);
              return acc;
            }, {})
          ).map(([date, entries]) => (
            <div key={date} className="mb-4">
              <Text strong className="text-lg">
                {date}
              </Text>
              {entries.map((entry, i) => (
                <div
                  key={i}
                  className="bg-white rounded-md shadow w-full my-2 p-2 flex justify-between items-center"
                >
                  <div className="flex items-center gap-3">
                    <Avatar style={{ backgroundColor: "#8400ff" }} size={38}>
                      {entry.employeeName.charAt(0).toUpperCase()}
                    </Avatar>
                    <div>
                      <Text strong>{entry.employeeName}</Text>
                      <Tag
                        className="bg-[#33EA26] text-white ml-2"
                        icon={<ClockCircleOutlined />}
                      >
                        {entry.minutesDifference} Min
                      </Tag>
                      <div className="text-gray-500 text-sm">
                        {entry.designationName}
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <ClockCircleOutlined className="text-md text-gray-500 mr-1" />
                    <Tag className="bg-[#FD0707] text-white">{entry.login}</Tag>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </Modal>
      </Row>

      <Row gutter={[16, 16]} align="stretch" className="p-2">
        <Col xs={24} sm={24} md={24} lg={24} xl={8} style={{ display: "flex" }}>
          <div className="bg-white rounded-md shadow w-full">
            <div className="p-5 flex justify-between items-center">
              <Typography.Title level={5} className="poppins-txt font-weight">
                Employees
              </Typography.Title>
              {employee_list?.data?.length > 5 && (
                <Button onClick={toggleEmployeeView}>
                  {isExpandedView ? "Show Less" : "View All"}
                </Button>
              )}
            </div>

            <Divider className="w-full" type="secondary" />

            <div
              style={{
                maxHeight: isExpandedView ? "400px" : "auto",
                overflowY: isExpandedView ? "auto" : "visible",
              }}
            >
              <div
                className="px-5 py-3 bg-gray-200 flex justify-between"
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                  backgroundColor: "#E5E7EB",
                }}
              >
                <Typography.Text strong>Name</Typography.Text>
                <Typography.Text strong>Department</Typography.Text>
              </div>

              {visibleEmployees.map((emp, index) => (
                <div key={emp._id || index}>
                  <div className="p-3 hover:bg-gray-100">
                    <div className="flex justify-between items-center">
                      <div className="flex items-center gap-3">
                        <Avatar
                          src={emp.profilePicture}
                          style={{
                            backgroundColor: "#8400ff",
                            textTransform: "capitalize",
                          }}
                          size={38}
                        >
                          {emp.employeeName?.charAt(0)}
                        </Avatar>
                        <div>
                          <Typography.Text strong>
                            {emp.employeeName}
                          </Typography.Text>
                          <div className="text-gray-500 text-sm">
                            {emp.designationId?.designationName}
                          </div>
                        </div>
                      </div>
                      <Tag color="cyan">{emp.departmentId?.departmentName}</Tag>
                    </div>
                  </div>
                  <Divider className="w-full" type="secondary" />
                </div>
              ))}
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={8} style={{ display: "flex" }}>
          <div className="bg-[#F8F13A] rounded-md shadow w-full py-2 px-3">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <Typography.Title
                  className="poppins-txt"
                  level={5}
                  style={{ color: "black", marginBottom: 0 }}
                >
                  Next Holiday
                </Typography.Title>
              </div>

              <div>
                <Button
                  style={{
                    marginTop: "5px",
                    background: "#ffff",
                    color: "black",
                  }}
                  type="primary"
                  size="medium"
                  className="custom-btn"
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  View All
                </Button>
              </div>
            </div>

            <div>
              {upcomingHoliday && firstGroup && firstGroup.items.length > 0 ? (
                <div style={{ marginTop: 10 }}>
                  <Typography.Text>
                    {moment(upcomingHoliday.date).format("MMM D, YYYY")}
                  </Typography.Text>

                  <div
                    key={`${firstGroup.items[0].holidayName}-0`}
                    style={{
                      background: "#F1FAFA",
                      borderRadius: 4,
                      padding: 8,
                      marginTop: 4,
                      border: "1px dashed gray",
                    }}
                  >
                    <Typography.Text
                      strong
                      style={{ textTransform: "capitalize" }}
                    >
                      {firstGroup.items[0].holidayName}
                    </Typography.Text>

                    <div
                      style={{
                        color: "gray",
                        fontSize: 12,
                        textTransform: "capitalize",
                      }}
                    >
                      {firstGroup.items[0].description}
                    </div>

                    <div
                      style={{
                        textAlign: "right",
                        fontSize: 12,
                        color: "#555",
                      }}
                    >
                      {moment(firstGroup.items[0].date).format("ddd, MMM D")}
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    background: "#F1FAFA",
                    borderRadius: 4,
                    padding: 8,
                    marginTop: 4,
                    border: "1px dashed gray",
                  }}
                >
                  <Typography.Text
                    strong
                    style={{ textTransform: "capitalize" }}
                  >
                    No Holidays
                  </Typography.Text>
                </div>
              )}
            </div>

            <Modal
              title={"Holidays"}
              open={showModal}
              onCancel={handleHolidayModalCancel}
              cancelText="Cancel"
              width={450}
              footer={null}
              maskClosable={false}
              centered
            >
              <div
                style={{
                  maxHeight: "500px",
                  overflowY: "auto",
                  paddingRight: "8px",
                }}
              >
                {limitedHolidayGroups.length > 0 ? (
                  limitedHolidayGroups.map(({ label, items }) => (
                    <div key={label} style={{ marginBottom: 16 }}>
                      <Typography.Text strong style={{ fontSize: 16 }}>
                        {label}
                      </Typography.Text>

                      {items.map((item, index) => (
                        <div
                          key={`${item.holidayName}-${index}`}
                          className="bg-[#F1FAFA] rounded-md shadow w-full my-2 border-dashed border border-gray-400"
                          style={{ padding: 10 }}
                        >
                          <div
                            className="p-2 flex justify-between items-start gap-4"
                            style={{ alignItems: "flex-start" }}
                          >
                            {/* Left: Name and Description */}
                            <div style={{ flex: 1 }}>
                              <Typography.Text
                                strong
                                style={{
                                  textTransform: "capitalize",
                                  fontSize: 14,
                                }}
                              >
                                {item.holidayName}
                              </Typography.Text>
                              <div
                                style={{
                                  color: "gray",
                                  fontSize: 12,
                                  textTransform: "capitalize",
                                }}
                              >
                                {item.description}
                              </div>
                            </div>

                            <div
                              style={{
                                minWidth: "90px",
                                textAlign: "right",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <Typography.Text
                                style={{ fontSize: 12, color: "#555" }}
                              >
                                {moment(item.date).format("ddd, MMM D")}
                              </Typography.Text>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))
                ) : (
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <Typography.Text>No Holidays</Typography.Text>
                  </div>
                )}
              </div>
            </Modal>
          </div>
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={8} style={{ display: "flex" }}>
          <div className="bg-white rounded-md shadow w-full">
            {/* Header */}
            <div className="p-5 flex justify-between">
              <Typography.Title level={5} className="poppins-txt font-weight">
                Birthdays
              </Typography.Title>
              <Button onClick={() => setShowBirthdayModal(true)}>
                View All
              </Button>
            </div>

            <Divider className="w-full" type="secondary" />

            {/* Scrollable Birthday List */}
            <div
              className="p-5"
              style={{
                maxHeight: "420px",
                overflowY: "auto",
                paddingRight: "8px",
              }}
            >
              {limitedGroups.map(([label, val]) => (
                <div key={label} style={{ marginBottom: 16 }}>
                  <Typography.Text strong style={{ fontSize: 16 }}>
                    {label}
                  </Typography.Text>

                  {val.items.map((item, index) => (
                    <div
                      key={`${item.employeeName}-${index}`}
                      className="bg-[#F1FAFA] rounded-md shadow w-full my-2 border-dashed border border-gray-400"
                      style={{ padding: 10 }}
                    >
                      <div
                        className="p-2 flex justify-between items-start gap-4"
                        style={{ alignItems: "flex-start" }}
                      >
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          <Avatar
                            size={38}
                            style={{
                              backgroundColor: "#8400ff",
                              textTransform: "capitalize",
                            }}
                          >
                            {item?.employeeName?.charAt(0)?.toUpperCase() || ""}
                          </Avatar>

                          <div>
                            <Typography.Text
                              strong
                              style={{
                                fontSize: 14,
                                textTransform: "capitalize",
                              }}
                            >
                              {item.employeeName}
                            </Typography.Text>
                            <div
                              style={{
                                color: "gray",
                                fontSize: 12,
                                textTransform: "capitalize",
                              }}
                            >
                              {item.designation}
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            minWidth: "70px",
                            textAlign: "right",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <Button
                            size="small"
                            className="custom-btn bg-[#403143] text-white"
                            icon={
                              <GiftOutlined className="text-md text-white" />
                            }
                          >
                            Send
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* 🎂 Modal for All Birthdays */}
          <Modal
            title={"Birthdays"}
            open={showBirthdayModal}
            onCancel={() => setShowBirthdayModal(false)}
            cancelText="Cancel"
            width={450}
            footer={null}
            maskClosable={false}
            centered
          >
            <div
              style={{
                maxHeight: "500px",
                overflowY: "auto",
                paddingRight: "8px",
              }}
            >
              {sortedAllGroups.length > 0 ? (
                sortedAllGroups.map(([label, val]) => (
                  <div key={label} style={{ marginBottom: 16 }}>
                    <Typography.Text strong style={{ fontSize: 16 }}>
                      {label}
                    </Typography.Text>

                    {val.items.map((item, index) => (
                      <div
                        key={`${item.employeeName}-${index}`}
                        className="bg-[#F1FAFA] rounded-md shadow w-full my-2 border-dashed border border-gray-400"
                        style={{ padding: 10 }}
                      >
                        <div
                          className="p-2 flex justify-between items-start gap-4"
                          style={{ alignItems: "flex-start" }}
                        >
                          <div
                            style={{
                              flex: 1,
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                            }}
                          >
                            <Avatar
                              size={38}
                              style={{
                                backgroundColor: "#8400ff",
                                textTransform: "capitalize",
                              }}
                            >
                              {item?.employeeName?.charAt(0)?.toUpperCase() ||
                                ""}
                            </Avatar>

                            <div>
                              <Typography.Text
                                strong
                                style={{
                                  fontSize: 14,
                                  textTransform: "capitalize",
                                }}
                              >
                                {item.employeeName}
                              </Typography.Text>
                              <div
                                style={{
                                  color: "gray",
                                  fontSize: 12,
                                  textTransform: "capitalize",
                                }}
                              >
                                {item.designation}
                              </div>
                            </div>
                          </div>

                          <div
                            style={{
                              minWidth: "70px",
                              textAlign: "right",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <Button
                              size="small"
                              className="custom-btn bg-[#403143] text-white"
                              icon={
                                <GiftOutlined className="text-md text-white" />
                              }
                            >
                              Send
                            </Button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                  <Typography.Text>No Birthdays</Typography.Text>
                </div>
              )}
            </div>
          </Modal>
        </Col>
      </Row>
    </div>
  );
};

export default AdminDashboard;
